<div class="notes-section">
    <p>By Default user temporary dealer code will get vanish after 24 hours of created time.
    </p>
</div>
<div class="container">
    <div class="input-section">
        <input type="text" placeholder="Enter a username..." [(ngModel)]="username" />
        <button type="submit" class="btn btn-primary" (click)="submitUserName()">GO</button>
        <button type="submit" class="btn btn-primary" (click)="getInactiveSessionList()">Get Expired Sessions</button>
    </div>
</div>
<div *ngIf="showErrorMessage" style="margin-left: 5%;" class="error-message">{{errorMsg}}</div>
<div class="container table-container" *ngIf="showTempDealerInputTable">
    <table class="table table-bordered">
        <thead>
            <tr>
                <th>Username</th>
                <th>Default Dealer Code</th>
                <th>Temporary Dealer Code</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>{{tempCodeDetails.username}}</td>
                <td>{{tempCodeDetails.dealerCode}}</td>
                <td><input type="text" class="form-control" [(ngModel)]="inputTempDealerCode"></td>
            </tr>
        </tbody>
    </table>
    <button type="submit" class="btn btn-primary" (click)="submitTempDealerCode()">Submit</button>
</div>
<div *ngIf="showTempDealerErrorMsg" style="margin-left: 5%;" class="error-message">Please enter to temp dealer code.
</div>
<div class="container" *ngIf="showTempDetailsWithCalendar">
    <table class="table table-bordered">
        <thead>
            <tr>
                <th>S.No</th>
                <th>username</th>
                <th>Default DealerCode</th>
                <th>Temp Dealer Code</th>
                <th>Expiry Date</th>
                <th>Actions</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let row of tempDealerCodeDetails; let i = index">
                <tr *ngIf="row.tempCode != null">
                    <td>{{ row.sno }}</td>
                    <td>{{ row.username }}</td>
                    <td>{{ row.dealerCode }}</td>
                    <td>{{ row.tempCode }}</td>
                    <td>
                        <ng-container *ngIf="!row.isEditing; else editTemplate">
                            {{row.expiryDate | date:'MM/dd/yyyy'}}
                        </ng-container>
                        <ng-template #editTemplate>
                            <input type="text" class="form-control" placeholder="Select Date" bsDatepicker
                                [(ngModel)]="row.selectedDate" [bsConfig]="bsConfig">
                        </ng-template>
                    </td>
                    <td>
                        <div style="display: flex; gap: 10px;">
                            <button class="btn btn-sm btn-primary" (click)="editRow(row)">{{ row.isEditing ? 'Save' :
                                'Edit'
                                }}</button>
                            <button class="btn btn-sm btn-danger" (click)="removeRow(row)">Remove</button>
                        </div>
                    </td>
                </tr>
            </ng-container>
            <tr *ngIf="tempDealerCodeDetails[0].tempCode == null">
                <td colspan="6" class="text-center">No more records found.</td>
            </tr>
        </tbody>
    </table>
</div>
<div class="inactive-session-container" *ngIf="showInactiveSessionDetails">
    <h5 class="inactive-session-title">Expired Session Details</h5>
    <table class="table table-bordered">
        <thead>
            <tr>
                <th>S.No</th>
                <th>UserName</th>
                <th>Markek Country</th>
                <th>Default DealerCode</th>
                <th>Temp Dealer Code</th>
                <th>Assignee</th>
                <th>Expiry Date</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let row of inactiveSessionDetails; let i = index">
                <tr *ngIf="row.tempdealercode != null">
                    <td>{{i + 1}}</td>
                    <td>{{ row.username }}</td>
                    <td>{{row.marketCountry}}</td>
                    <td>{{ row.dealerCode }}</td>
                    <td>{{ row.tempdealercode }}</td>
                    <td>{{row.assigneeUserName}}</td>
                    <td>{{row.expiringtimestamp | date:'MM/dd/yyyy' }}</td>
                </tr>
            </ng-container>
            <tr *ngIf="inactiveSessionDetails.length == 0">
                <td colspan="6" class="text-center">No more records found.</td>
            </tr>
        </tbody>
    </table>
</div>